const moduleMap = {
	"./authentication": () => {
		return Promise.all([__webpack_require__.e(1505), __webpack_require__.e(3568), __webpack_require__.e(896), __webpack_require__.e(9111), __webpack_require__.e(9849), __webpack_require__.e(2084)]).then(() => (() => ((__webpack_require__(2084)))));
	},
	"./session": () => {
		return Promise.all([__webpack_require__.e(1505), __webpack_require__.e(896), __webpack_require__.e(9111), __webpack_require__.e(9849), __webpack_require__.e(3868), __webpack_require__.e(1158)]).then(() => (() => ((__webpack_require__(1158)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});